import BookingForm from "@/components/BookingForm";
import { Palette, Sparkles, Star, Heart } from "lucide-react";
import Seo from "@/components/Seo";

export default function Bespoke() {
  return (
    <div className="page-transition pt-[72px]" data-testid="bespoke-page">
      <Seo
        title="Bespoke Floral Design & Custom Arrangements | Fleuris Noir"
        description="Bespoke floral design from Fleuris Noir, a luxury Minneapolis florist. Custom arrangements and consultations tailored to your occasion across the Twin Cities."
        path="/bespoke"
        jsonLd={{
          "@context": "https://schema.org", "@type": "Service",
          serviceType: "Bespoke Floral Design",
          provider: { "@type": "Florist", name: "Fleuris Noir", telephone: "+1-612-547-9260", areaServed: "Minneapolis, Minnesota" },
          areaServed: "Twin Cities Metropolitan Area",
        }}
      />
      {/* Hero */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundImage: `url('https://images.unsplash.com/photo-1760373071711-960143464e34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmbG9yaXN0JTIwc2hvcHxlbnwwfHx8fDE3NzYyNjIwMzl8MA&ixlib=rb-4.1.0&q=85')` 
          }}
        />
        <div className="hero-overlay absolute inset-0" />
        
        <div className="relative z-10 text-center px-6">
          <p className="overline mb-4">Personalized Design</p>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#f8f5f0]">
            Bespoke Arrangements
          </h1>
        </div>
      </section>

      {/* Intro */}
      <section className="section bg-[#0c0c0c]">
        <div className="container-custom max-w-3xl text-center">
          <p className="font-body text-lg text-[#a19d98] leading-relaxed">
            At Fleuris Noir, we believe that truly exceptional florals should be as unique as the 
            moments they celebrate. Our bespoke service offers a collaborative design experience, 
            where your vision meets our artistry to create something extraordinary.
          </p>
        </div>
      </section>

      {/* Process */}
      <section className="section bg-[#161616]">
        <div className="container-custom">
          <div className="text-center mb-16">
            <p className="overline mb-4">The Process</p>
            <h2 className="font-heading text-3xl text-[#f8f5f0]">
              How It Works
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              {
                icon: <Palette className="text-[#b8966a]" size={24} />,
                title: "Consultation",
                desc: "Share your vision, occasion, and preferences with our design team."
              },
              {
                icon: <Sparkles className="text-[#b8966a]" size={24} />,
                title: "Design Proposal",
                desc: "Receive a custom mood board and detailed proposal for your arrangement."
              },
              {
                icon: <Star className="text-[#b8966a]" size={24} />,
                title: "Refinement",
                desc: "Collaborate with us to perfect every detail until it's exactly right."
              },
              {
                icon: <Heart className="text-[#b8966a]" size={24} />,
                title: "Creation",
                desc: "Watch as our artisans bring your vision to life with the finest blooms."
              }
            ].map((step, i) => (
              <div key={i} className="text-center">
                <div className="w-12 h-12 mx-auto mb-4 border border-[#b8966a]/20 flex items-center justify-center">
                  {step.icon}
                </div>
                <h3 className="font-heading text-lg text-[#f8f5f0] mb-2">{step.title}</h3>
                <p className="font-body text-sm text-[#a19d98]">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Booking Form */}
      <section className="section bg-[#0c0c0c]">
        <div className="container-custom max-w-4xl">
          <BookingForm 
            bookingType="bespoke" 
            title="Schedule Your Consultation" 
          />
        </div>
      </section>
    </div>
  );
}
